import React from "react";
import { Upload, message } from "antd";
import { prefixFile } from "@/fetch/fetchApi";

// 通用上传组件
class UploadGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      max: props.max || 1,
      oldFileList: [],
    };
  }

  uploadChange = ({ fileList, file }) => {
    // cover， 开启之后会自动把当前上传文件覆盖到最大长度的最后一项
    if (this.state.oldFileList.length > this.state.max && !this.props.cover) {
      message.error("超出最大上传数量");
      return;
    }
    this.setState({
      fileList,
    });
    console.log(file);
    // 如果接口未抛出错误码，组件认为上传成功,需置为error
    if (file.status === "done" && !file.response.fileIdList) {
      message.error("上传失败");

      file.status = "error";
    }
    if (file.status === "done") {
      let results = JSON.parse(JSON.stringify(fileList));
      if (this.props.cover && this.state.oldFileList.length === this.state.max) {
        // 如果开启覆盖模式，把之前的最后一个文件清楚
        results = fileList.filter((v, index) => index !== this.state.max - 1);
        this.setState({
          fileList: results,
        });
      }
      this.setState({
        oldFileList: results,
      });

      this.props.valueChange(results);
    }
    if (file.status === "error") {
      this.setState({
        fileList: this.state.oldFileList,
      });
    }
  };

  beforeUpload = (file) => {
    // 是否为有效的上传格式
    let isValid = true;

    if (this.props.types) {
      // 如果需要格式校验，请传入格式校验列表
      const strs = file.name.split(".");
      // 判断文件名截取后的最后一项是否为 xx格式文件
      isValid = this.props.types.includes(strs[strs.length - 1]);
    }

    return isValid;
  };

  render() {
    const uploadProps = {
      action: `${prefixFile}${this.props.uploadPath || "/uploadFile.do"}`,
      fileList: this.state.fileList,
      onChange: this.uploadChange,
      multiple: false,
      beforeUpload: this.beforeUpload,
      data: (file) => {
        const fileName = file.name;
        const dataArr = fileName.split("_");
        return {
          storeName: "firmware_charing_upload",
          filePath: `/${dataArr[3]}/${fileName}`,
        };
      },
      ...this.props.uploadProps,
    };
    return <Upload {...uploadProps}>{this.props.children}</Upload>;
  }
}

export default UploadGeneral;



// WEBPACK FOOTER //
// ./src/AntD/components/display/upload/uploadGeneral.js